import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import axiosInstance from '../../api/axiosInstance';
// Forget Password API call
export const forgetPassword = createAsyncThunk(
  'auth/forgetPassword',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('/api/Common/ForgetPassword', payload);
      return response.data;     
    
       
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Validate Token API call
export const validateToken = createAsyncThunk(
    'auth/validateToken',
    async (payload, { rejectWithValue }) => {
      try {
        const response = await axiosInstance.post('/api/Common/ValidateForgetToken', payload);
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  );
  
// Change Password API call
export const changePasswordAfterForget = createAsyncThunk(
  'auth/changePasswordAfterForget',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('/api/Common/ChangePasswordAfterForget', payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
const forgetPasswordSlice = createSlice({
    name: 'forgetPassword',
    initialState: {
      loading: false,
      error: null,
      successMessage: null,
      tokencode: null, // Holds the token for the next step
      tokenValidated: false, // Tracks if the token is successfully validated
    },
    reducers: {
      clearState: (state) => {
        state.loading = false;
        state.error = null;
        state.successMessage = null;
        state.tokencode = null;
        state.tokenValidated = false;
      },
    },
    extraReducers: (builder) => {
      builder
        // Forget Password
        .addCase(forgetPassword.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(forgetPassword.fulfilled, (state, action) => {
          state.loading = false;
          const { message } = action.payload;
          state.successMessage = message?.message || 'Reset code sent';
          state.tokencode = message?.tokencode || null;
        })
        .addCase(forgetPassword.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload?.errormessage || 'An error occurred';
        })
  
        // Validate Token
        .addCase(validateToken.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(validateToken.fulfilled, (state, action) => {
          state.loading = false;
          state.tokenValidated = true;
          state.successMessage = action.payload?.message || 'Token validated successfully';
        })
        .addCase(validateToken.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload?.errormessage || 'Invalid token';
        })
  
        // Change Password After Forget
        .addCase(changePasswordAfterForget.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(changePasswordAfterForget.fulfilled, (state, action) => {
          state.loading = false;
          state.successMessage = action.payload.message;
        })
        .addCase(changePasswordAfterForget.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload?.errormessage || 'An error occurred';
        });
    },
  });
  
  export const { clearState } = forgetPasswordSlice.actions;
  export default forgetPasswordSlice.reducer;